import { Route } from "react-router";
import NotFoundPage from "./NotFound";

export default (<Route path="*" render={({ staticContext }) => {
    if (staticContext) {
        staticContext.statusCode = 404
    }
    return <NotFoundPage />
}} />)